import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Loader from '../../../../../shared/components/loader';
import CONSTANT from './../../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
 import CustomExpandableTable from '../../../../../shared/components/customExpandableTable';
 import Pagination from './../../../../../shared/components/pagination';
import moment from 'moment';
import Util from './../../../../../shared/util/util'
import CargoAllocationService from './../../../../../cargoallocation/services/cargoallocation.service'
import TripServices from './../../../../services/firstAndLastmilemanagement.service'
import Treeselect from '@riophae/vue-treeselect';
export default {
  name: 'UADCutoffs',
  components: {
    BasicSelect,
    VueElementLoading,
    DatePicker,
    moment,
    CustomExpandableTable,
    Validator,
    Pagination,
    Treeselect
  },
  data() {
    return {
      tableColumn: ['Modification Date', 'Facility Type', 'Facility Name','RAD Cut-off','UAD Cut-off','User name'],
      innerTableColumn: ['Assigned Zones'],
      tableItems: [],
    HubNameArr:[],
    totalCount : 0,
    cutOffTimeArr:[{id:'01:00',label:'01:00'},
    {id:'01:30',label:'01:30'},
    {id:'02:00',label:'02:00'},
    {id:'02:30',label:'02:30'},
    {id:'03:00',label:'03:00'},
    {id:'03:30',label:'03:30'},
    {id:'04:00',label:'04:00'},
    {id:'04:30',label:'04:30'},
    {id:'05:00',label:'05:00'},
    {id:'05:30',label:'05:30'},
    {id:'06:00',label:'06:00'},
    {id:'06:30',label:'06:30'},
    {id:'07:00',label:'07:00'},
    {id:'07:30',label:'07:30'},
    {id:'08:00',label:'08:00'},
    {id:'08:30',label:'08:30'},
    {id:'09:00',label:'09:00'},
    {id:'09:30',label:'09:30'},
    {id:'10:00',label:'10:00'},
    {id:'10:30',label:'10:30'},
    {id:'11:00',label:'11:00'},
    {id:'11:30',label:'11:30'},
    {id:'12:00',label:'12:00'},
    {id:'12:30',label:'12:30'}],
    facilitytypeArr:[{value:'SVC',text:'SVC'}],
    facilitytypeflag:true,
    UADAMPM : null,
    RADAMPM: null,
    isLoading: false,
    UADAMPMoptions:[{id:'AM',label:'AM'},{id:'PM',label:'PM'}],
    selectedUADAMPM : {id:'',label:''},
    RADAMPMoptions:[{label:'AM',id:'AM'},{label:'PM',id:'PM'}],
    selectedRADAMPM : {id:'',label:''},
    HubName:'',
    CutOffTime: null,
    UADCutOffTime:null,
    facilitytype:'SVC',
    selectedfacilitype:{value:'SVC',text:'SVC'},
    selectedHubName:{value:'',text:''},
    selectedCutOffTime:{},
    selectedHubName:{value:'',text:''},
    selectedUADCutOffTime:{id:'',label:''},
    totalPage : 0,
    offset : 0,
    pageLimit:10,
    currentPage: 1,
    huberr:'',
    radcutofferr:'',
    radampmerr:'',
    uadcutofferr:'',
    uadampmerr:''

    }
  },
  computed: {},
   mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;
    this.localuserid = userdetail.userid;
    this.hubid = userdetail.hubID[0];
    // this.userrole = parseInt(userdetail.userrole);
    this.userrole = userdetail.rolename[0];
    this.isLoading = true;
    this.facilitytypeflag = true
     this.GetUADLogs()
     this.loadAllHubAccessList()

  },
  methods: {
    onPageChange(page) {
     this.currentPage = page;
     this.offset = (page - 1) * this.pageLimit
     this.GetUADLogs();
   },
    async loadAllHubAccessList() {
      try {
        let InputPayload = {
            userid: this.localuserid
        };
        this.isLoading = true;
        let response = await CargoAllocationService.getHubAccessList(InputPayload);
        this.isLoading = false;
        if(response.data.code===200){
          this.HubNameArr.push({'value':0,'text':'DEFAULT'})
          this.hubaccess = response.data.data.hubaccess;
          for (var i = 0; i < this.hubaccess.length; i++) {
            this.HubNameArr.push({
              'value': this.hubaccess[i].HubID,
              'text': this.hubaccess[i].HubName
            })
          }
        }
        else {
          this.$alertify.error(response.data.message);
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
   onSubmitSearch(){
    // this.SetUADCutOff()
  },
  checkErr(){
    let err = false
    console.log("this.selectedHubName.value",this.selectedHubName.value);
    if(this.selectedHubName.value = '' || this.selectedHubName.text == ''){
      err=true
      this.huberr = 'Please select Hub'
    }
    if(this.CutOffTime == null || this.CutOffTime == undefined || this.CutOffTime.id == ''){
      err = true
      this.radcutofferr = 'Please Select RAD Cut-off time'
    }
    if(this.UADCutOffTime == null || this.UADCutOffTime == undefined || this.UADCutOffTime.id == ''){
      err = true
      this.uadcutofferr = 'Please Select UAD Cut-off time'
    }
    if(this.RADAMPM == null || this.RADAMPM == ''){
      err = true
      this.radampmerr = 'Please select AM/PM'
    }
    if(this.UADAMPM == null || this.UADAMPM == ''){
      err = true
      this.uadampmerr = 'Please select AM/PM'
    }
    return err
  },
    async SetUADCutOff() {
      try {
        if(this.checkErr()){
          return false
        }
        this.isLoading = true;
        let InputPayload = {
          hubid: this.HubName,
          hubname: this.selectedHubName.text,
          radtime: this.CutOffTime == undefined ? '' : this.CutOffTime.id,
          radAMPM: this.RADAMPM,
          uadtime: this.UADCutOffTime == undefined ? '': this.UADCutOffTime.id,
          uadAMPM: this.UADAMPM,
          lastmodifiedby: this.useremail
        };
        let response = await TripServices.SetUADCutOff(InputPayload);
        this.isLoading = false;
        if(response.data.code===200){
          this.clearForm()
          this.GetUADLogs()
          this.$alertify.success(response.data.message)
        }
        else {
          this.$alertify.error(response.data.message);
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },

    async GetUADLogs() {
      try {
        this.isLoading = true;
        this.tableItems = [];
        this.totalCount = 0;
        this.defaultcount = [];
        let inputPayload = {
          defaulthubid: this.hubid,
          userid : this.localuserid,
          offset :this.offset,
          limit : this.pageLimit,
        };
        let result = await TripServices.GetUADLogs(inputPayload);
        if (result.data.code == 200) {
          this.totalCount = Number(result.data.data.activecount);
          if (this.totalCount > 0) {
            this.defaultcount = result.data.data.default
            if(this.defaultcount.length>0){
              this.selectedHubName.text = this.defaultcount[0].hubname
              this.selectedHubName.value = this.defaultcount[0].hubid
              this.HubName = this.selectedHubName.value
              this.CutOffTime = {
                id:this.defaultcount[0].radtime,
                label:this.defaultcount[0].radtime
              }
              this.RADAMPM = this.defaultcount[0].radAMPM
              this.selectedRADAMPM.label = this.defaultcount[0].radAMPM
              this.UADCutOffTime = {
                id:this.defaultcount[0].uadtime,
                label:this.defaultcount[0].uadtime
              }
              // this.selectedUADCutOffTime.label = this.defaultcount[0].uadtime
              this.UADAMPM = this.defaultcount[0].uadAMPM
              this.selectedUADAMPM.label = this.defaultcount[0].uadAMPM
            }
            this.tableItems = result.data.data.active.map((el,index) => {
              return {
                "id":index+1,
                "Modification Date": moment.utc(el.lastmodifieddate).format("DD-MM-YYYY HH:mm:ss").valueOf(),
                "Facility Type":'SVC',
                "Facility Name":el.hubname,
                "RAD Cut-off":el.radinscandate,
                "UAD Cut-off":el.uadcutoff,
                "User name":el.lastmodifiedby,
              };
            });
          } else {
            this.tableItems = [];
          }
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1;
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        // await this.GetUADLogs();
        this.isLoading = false;
      }
    },
    selectHubName(data){
      this.selectedHubName = data;
      this.HubName = data.value;
      this.huberr = ''
    },
    selectUADAMPM(data) {
      this.selectedUADAMPM = data;
      this.UADAMPM = data.id
      this.uadampmerr = ''
    },
    selectRADAMPM(data) {
      this.selectedRADAMPM = data;
      this.RADAMPM = data.id
      this.radampmerr = ''
    },
    selectCutOffTime(data){
      this.selectedCutOffTime = data;
      this.CutOffTime = data.id
      this.radcutofferr = ''
    },
    selectUADCutOffTime(data){
      this.selectedUADCutOffTime = data;
      this.UADCutOffTime = data.id
      this.uadcutofferr = ''
    },
clearForm(){
  this.selectedRADAMPM = {id: '',label:''}
  this.selectedUADAMPM = {id:'',label:''}
  this.UADAMPM = null
  this.CutOffTime = null
  this.UADCutOffTime=null
  this.RADAMPM = null
  this.selectedHubName = {value:'',text:''}
  this.selectedUADCutOffTime.id= ''
  this.selectedUADCutOffTime.label = ''
  this.selectedCutOffTime = {}
  this.huberr = ''
  this.radampmerr = ''
  this.uadampmerr= ''
  this.uadcutofferr = ''
  this.radcutofferr = ''
},
selectfacilitytype(data){
this.selectedfacilitype = data
this.facilitytype = data.value
},
// selectCutOffTime(){},
// selectUADCutOffTime(){},
// selectCutOffTime(){},
getCustomTableEvent(){}

},

}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/configuration/UADConfiguration/UADcutoffs/UADcutoffs.component.js